<script>
  import SlideIt from "svelte-glidejs";

  let options = {
    type: "slide",
    focusAt: "center",
    direction: "ltr",
    startAt: 0,
    perView: 1,
    gap: 0,
    hoverpause: true,
    autoplay: 5000,
  };
  export let height = "300";
  let listslide = [
    {
      title: "#ConnectionEverywhere",
      subtitle: "Connections on each side",
      img:
        "https://images.unsplash.com/photo-1606778303077-3780ea8d5420?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1260&h=" +
        height +
        "&q=80",
      url: "./",
    },
    {
      title: "#EmpowermentTrigger",
      subtitle: "Wifi connection for developing rural areas",
      img:
        "https://images.unsplash.com/photo-1533709752211-118fcaf03312?ixlib=rb-1.2.1&auto=format&fit=crop&w=1260&h=" +
        height +
        "&q=80",
      url: "./",
    },
    {
      title: "#TheWorldInYourHand",
      subtitle: "Always Connected To The Wide World",
      img:
        "https://images.unsplash.com/photo-1574405345169-f45c7d66480e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1260&h=" +
        height +
        "&q=80",
      url: "./",
    },
  ];
</script>

<div
  class="relative w-full overflow-hidden bg-white bg-opacity-100 rounded-lg shadow-2xl lg:rounded-lg lg:bg-white lg:bg-opacity-75"
>
  <SlideIt {options} bullet="true" control="true" items={listslide}>
    <a
      slot="item"
      let:item
      href={item.url}
      class="block w-full leading-tight text-black bg-indigo-700 rounded-lg shadow-lg lg:p-10 "
      style="height:{height}px;background: url('{item.img}') center center / cover;"
    >
      <div class="w-full pt-16 pl-0 text-center lg:pt-0 lg:pl-5 lg:text-left">
        <h2 class="mb-2 text-2xl font-light lg:text-4xl">
          <span class="px-2 bg-white bg-opacity-75 rounded"
            >{item.subtitle}</span
          >
        </h2>
        <h3 class="text-2xl font-bold lg:text-4xl">
          <span class="px-2 bg-white bg-opacity-75 rounded">{item.title}</span>
        </h3>
      </div>
    </a>
  </SlideIt>
</div>
